import filter from 'lodash/filter'
import get from 'lodash/get'
import map from 'lodash/map'
import sumBy from 'lodash/sumBy'

// TODO: this labeling is manually maintained because we haven't
// moved this file to typescript (so we could use the generated enums).
export const PROCESSING_STATUS = 'Processing'
export const ERROR_STATUS = 'Failed'
export const REFUND_PROCESSING_STATUS = 'Refund Processing'
export const PAID_STATUS = 'Paid'
export const PENDING_STATUS = 'Pending'
export const REFUND_STATUS = 'Refunded'
export const REFUND_ERROR = 'Refund Error'
const TOTAL_EXCLUDED_STATUS = [
  REFUND_PROCESSING_STATUS,
  ERROR_STATUS,
  REFUND_ERROR,
]

export const ACH_TYPE = 'ACH'
export const CC_TYPE = 'CREDIT_CARD'
export const SEPA_TYPE = 'SEPA'

export const getConnectedProvider = (connectedProviders, selectedProvider) =>
  connectedProviders.find(
    (connectedProvider) =>
      connectedProvider.paymentProvider === selectedProvider,
  )

export const getConnectionId = (connectedProviders, selectedProvider) => {
  const connectedProvider = getConnectedProvider(
    connectedProviders,
    selectedProvider,
  )
  return get(connectedProvider, 'externalIdentifier', '')
}

export const isSepaEnabled = (connectedProviders, selectedProvider) => {
  const connectedProvider = getConnectedProvider(
    connectedProviders,
    selectedProvider,
  )
  return get(connectedProvider, 'isSepaEnabled', false)
}

export const isAchEnabled = (connectedProviders, selectedProvider) => {
  const connectedProvider = getConnectedProvider(
    connectedProviders,
    selectedProvider,
  )
  return get(connectedProvider, 'isAchEnabled', false)
}

export const isConnectedToProvider = (connectedProviders, selectedProvider) =>
  Boolean(getConnectionId(connectedProviders, selectedProvider))

export const getPaymentStatus = (payment) => {
  switch (payment.status) {
    case 'PROCESSING':
      return PROCESSING_STATUS
    case 'ERROR':
      return ERROR_STATUS
    case 'REFUND_PROCESSING':
      return REFUND_PROCESSING_STATUS
    case 'REFUND_ERROR':
      return REFUND_ERROR
    case 'PENDING':
      return PENDING_STATUS
    case 'REFUND':
      return REFUND_STATUS
    case 'SUCCESS':
    default:
      return payment.amount >= 0 ? PAID_STATUS : REFUND_STATUS
  }
}
export const transformPaymentRecords = (paymentRecords) =>
  map(paymentRecords, (record) => ({
    id: record.orderId,
    amount: record.amount,
    date: record.created,
    status: getPaymentStatus(record),
    currencyCode: record.currency.toUpperCase(),
    last4: record.paymentMethod?.last4,
    billingName: record.paymentMethod?.billingName,
    billingEmail: record.paymentMethod?.billingEmail,
    type: record.paymentMethod?.type,
    methodName: record.paymentMethod?.brand || record.paymentMethod?.bankName,
    localAmount: record.localAmount,
    localCurrency: record.localCurrency,
    externalIdentifier: record.externalIdentifier,
    errorMessage: record.errorMessage,
  }))

export const getPaymentInfo = (orderId, paymentData, manualPaymentRecords) => {
  if (typeof orderId === 'undefined' || typeof paymentData === 'undefined') {
    return undefined
  }
  const orderPaymentData = filter(
    paymentData,
    (record) => record.id === orderId,
  )
  const orderManualPaymentData = filter(
    manualPaymentRecords,
    (record) => record.orderId === orderId,
  )
  return {
    total:
      sumBy(orderPaymentData, (record) =>
        !TOTAL_EXCLUDED_STATUS.includes(record.status) ? record.amount : 0,
      ) + sumBy(orderManualPaymentData, (record) => record.amount),
    localTotal: sumBy(orderPaymentData, (record) =>
      !TOTAL_EXCLUDED_STATUS.includes(record.status) ? record.localAmount : 0,
    ),
    payments: [
      ...orderPaymentData.map((record) => ({
        ...record,
        amount: Math.abs(record.amount),
      })),
      ...orderManualPaymentData,
    ],
  }
}
